/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $1f65399781f6270b$var$directives = new WeakMap();
const $1f65399781f6270b$export$99b43ad1ed32e735 = (f)=>(...args)=>{
        const d = f(...args);
        $1f65399781f6270b$var$directives.set(d, true);
        return d;
    };
const $1f65399781f6270b$export$4b5d79f26e0e3ad5 = (o)=>{
    return typeof o === "function" && $1f65399781f6270b$var$directives.has(o);
};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * True if the custom elements polyfill is in use.
 */ const $171cfc78f780daae$export$52a61c3a7415f2b1 = typeof window !== "undefined" && window.customElements != null && window.customElements.polyfillWrapFlushCallback !== undefined;
const $171cfc78f780daae$export$4cae3494608af418 = (container, start, end = null, before = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
const $171cfc78f780daae$export$77f49a256021c8de = (container, start, end = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};


/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */ const $256f3772b55f662d$export$9c068ae9cc5db4e8 = {};
const $256f3772b55f662d$export$45b790e32b2810ee = {};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */ const $5aff7fadf259646c$export$ffc4d0086f1a4c9 = `{{lit-${String(Math.random()).slice(2)}}}`;
const $5aff7fadf259646c$export$36b8314a2f34ed60 = `<!--${$5aff7fadf259646c$export$ffc4d0086f1a4c9}-->`;
const $5aff7fadf259646c$export$8c751b9db6965af4 = new RegExp(`${$5aff7fadf259646c$export$ffc4d0086f1a4c9}|${$5aff7fadf259646c$export$36b8314a2f34ed60}`);
const $5aff7fadf259646c$export$552ff45b274cc170 = "$lit$";
class $5aff7fadf259646c$export$14416b8d99d47caa {
    constructor(result, element){
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings: strings, values: { length: length } } = result;
        while(partIndex < length){
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */ ) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length: length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for(let i = 0; i < length; i++)if ($5aff7fadf259646c$var$endsWith(attributes[i].name, $5aff7fadf259646c$export$552ff45b274cc170)) count++;
                    while(count-- > 0){
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = $5aff7fadf259646c$export$a5d53adfffe6a300.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + $5aff7fadf259646c$export$552ff45b274cc170;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split($5aff7fadf259646c$export$8c751b9db6965af4);
                        this.parts.push({
                            type: "attribute",
                            index: index,
                            name: name,
                            strings: statics
                        });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            } else if (node.nodeType === 3 /* Node.TEXT_NODE */ ) {
                const data = node.data;
                if (data.indexOf($5aff7fadf259646c$export$ffc4d0086f1a4c9) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split($5aff7fadf259646c$export$8c751b9db6965af4);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for(let i = 0; i < lastIndex; i++){
                        let insert;
                        let s = strings[i];
                        if (s === "") insert = $5aff7fadf259646c$export$46b32044f78fe9b1();
                        else {
                            const match = $5aff7fadf259646c$export$a5d53adfffe6a300.exec(s);
                            if (match !== null && $5aff7fadf259646c$var$endsWith(match[2], $5aff7fadf259646c$export$552ff45b274cc170)) s = s.slice(0, match.index) + match[1] + match[2].slice(0, -$5aff7fadf259646c$export$552ff45b274cc170.length) + match[3];
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({
                            type: "node",
                            index: ++index
                        });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === "") {
                        parent.insertBefore($5aff7fadf259646c$export$46b32044f78fe9b1(), node);
                        nodesToRemove.push(node);
                    } else node.data = strings[lastIndex];
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            } else if (node.nodeType === 8 /* Node.COMMENT_NODE */ ) {
                if (node.data === $5aff7fadf259646c$export$ffc4d0086f1a4c9) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore($5aff7fadf259646c$export$46b32044f78fe9b1(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({
                        type: "node",
                        index: index
                    });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) node.data = "";
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                } else {
                    let i = -1;
                    while((i = node.data.indexOf($5aff7fadf259646c$export$ffc4d0086f1a4c9, i + 1)) !== -1){
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({
                            type: "node",
                            index: -1
                        });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove)n.parentNode.removeChild(n);
    }
}
const $5aff7fadf259646c$var$endsWith = (str, suffix)=>{
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const $5aff7fadf259646c$export$93919229d19012c8 = (part)=>part.index !== -1;
const $5aff7fadf259646c$export$46b32044f78fe9b1 = ()=>document.createComment("");
const $5aff7fadf259646c$export$a5d53adfffe6a300 = // eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;


class $ab7394fbe791605c$export$6eecef7813f38266 {
    constructor(template, processor, options){
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
    update(values) {
        let i = 0;
        for (const part of this.__parts){
            if (part !== undefined) part.setValue(values[i]);
            i++;
        }
        for (const part of this.__parts)if (part !== undefined) part.commit();
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = (0, $171cfc78f780daae$export$52a61c3a7415f2b1) ? this.template.element.content.cloneNode(true) : document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while(partIndex < parts.length){
            part = parts[partIndex];
            if (!(0, $5aff7fadf259646c$export$93919229d19012c8)(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while(nodeIndex < part.index){
                nodeIndex++;
                if (node.nodeName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === "node") {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            } else this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            partIndex++;
        }
        if (0, $171cfc78f780daae$export$52a61c3a7415f2b1) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
}


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @module lit-html
 */ 

/**
 * Our TrustedTypePolicy for HTML which is declared using the html template
 * tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 */ const $99e433cdec05ae56$var$policy = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
    createHTML: (s)=>s
});
const $99e433cdec05ae56$var$commentMarker = ` ${(0, $5aff7fadf259646c$export$ffc4d0086f1a4c9)} `;
class $99e433cdec05ae56$export$ce95ebd39b69fb27 {
    constructor(strings, values, type, processor){
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */ getHTML() {
        const l = this.strings.length - 1;
        let html = "";
        let isCommentBinding = false;
        for(let i = 0; i < l; i++){
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf("<!--");
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) && s.indexOf("-->", commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = (0, $5aff7fadf259646c$export$a5d53adfffe6a300).exec(s);
            if (attributeMatch === null) // We're only in this branch if we don't have a attribute-like
            // preceding sequence. For comments, this guards against unusual
            // attribute values like <div foo="<!--${'bar'}">. Cases like
            // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
            // below.
            html += s + (isCommentBinding ? $99e433cdec05ae56$var$commentMarker : (0, $5aff7fadf259646c$export$36b8314a2f34ed60));
            else // For attributes we use just a marker sentinel, and also append a
            // $lit$ suffix to the name to opt-out of attribute-specific parsing
            // that IE and Edge do for style and certain SVG attributes.
            html += s.substr(0, attributeMatch.index) + attributeMatch[1] + attributeMatch[2] + (0, $5aff7fadf259646c$export$552ff45b274cc170) + attributeMatch[3] + (0, $5aff7fadf259646c$export$ffc4d0086f1a4c9);
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement("template");
        let value = this.getHTML();
        if ($99e433cdec05ae56$var$policy !== undefined) // this is secure because `this.strings` is a TemplateStringsArray.
        // TODO: validate this when
        // https://github.com/tc39/proposal-array-is-template-object is
        // implemented.
        value = $99e433cdec05ae56$var$policy.createHTML(value);
        template.innerHTML = value;
        return template;
    }
}
class $99e433cdec05ae56$export$36e852975bbbeae0 extends $99e433cdec05ae56$export$ce95ebd39b69fb27 {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0, $171cfc78f780daae$export$4cae3494608af418)(content, svgElement.firstChild);
        return template;
    }
}



const $a0883e0a079a95ab$export$c3825b437cbdea5c = (value)=>{
    return value === null || !(typeof value === "object" || typeof value === "function");
};
const $a0883e0a079a95ab$export$9652023d9040757 = (value)=>{
    return Array.isArray(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(value && value[Symbol.iterator]);
};
class $a0883e0a079a95ab$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for(let i = 0; i < strings.length - 1; i++)this.parts[i] = this._createPart();
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */ _createPart() {
        return new $a0883e0a079a95ab$export$da9b3ca39c846561(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === "" && strings[1] === "") {
            const v = parts[0].value;
            if (typeof v === "symbol") return String(v);
            if (typeof v === "string" || !$a0883e0a079a95ab$export$9652023d9040757(v)) return v;
        }
        let text = "";
        for(let i = 0; i < l; i++){
            text += strings[i];
            const part = parts[i];
            if (part !== undefined) {
                const v = part.value;
                if ($a0883e0a079a95ab$export$c3825b437cbdea5c(v) || !$a0883e0a079a95ab$export$9652023d9040757(v)) text += typeof v === "string" ? v : String(v);
                else for (const t of v)text += typeof t === "string" ? t : String(t);
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
}
class $a0883e0a079a95ab$export$da9b3ca39c846561 {
    constructor(committer){
        this.value = undefined;
        this.committer = committer;
    }
    setValue(value) {
        if (value !== (0, $256f3772b55f662d$export$9c068ae9cc5db4e8) && (!$a0883e0a079a95ab$export$c3825b437cbdea5c(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!(0, $1f65399781f6270b$export$4b5d79f26e0e3ad5)(value)) this.committer.dirty = true;
        }
    }
    commit() {
        while((0, $1f65399781f6270b$export$4b5d79f26e0e3ad5)(this.value)){
            const directive = this.value;
            this.value = (0, $256f3772b55f662d$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.value === (0, $256f3772b55f662d$export$9c068ae9cc5db4e8)) return;
        this.committer.commit();
    }
}
class $a0883e0a079a95ab$export$a354997aeda6e93 {
    constructor(options){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendInto(container) {
        this.startNode = container.appendChild((0, $5aff7fadf259646c$export$46b32044f78fe9b1)());
        this.endNode = container.appendChild((0, $5aff7fadf259646c$export$46b32044f78fe9b1)());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendIntoPart(part) {
        part.__insert(this.startNode = (0, $5aff7fadf259646c$export$46b32044f78fe9b1)());
        part.__insert(this.endNode = (0, $5aff7fadf259646c$export$46b32044f78fe9b1)());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterPart(ref) {
        ref.__insert(this.startNode = (0, $5aff7fadf259646c$export$46b32044f78fe9b1)());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) return;
        while((0, $1f65399781f6270b$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $256f3772b55f662d$export$9c068ae9cc5db4e8);
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === (0, $256f3772b55f662d$export$9c068ae9cc5db4e8)) return;
        if ($a0883e0a079a95ab$export$c3825b437cbdea5c(value)) {
            if (value !== this.value) this.__commitText(value);
        } else if (value instanceof (0, $99e433cdec05ae56$export$ce95ebd39b69fb27)) this.__commitTemplateResult(value);
        else if (value instanceof Node) this.__commitNode(value);
        else if ($a0883e0a079a95ab$export$9652023d9040757(value)) this.__commitIterable(value);
        else if (value === (0, $256f3772b55f662d$export$45b790e32b2810ee)) {
            this.value = (0, $256f3772b55f662d$export$45b790e32b2810ee);
            this.clear();
        } else // Fallback, will render the string representation
        this.__commitText(value);
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) return;
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? "" : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === "string" ? value : String(value);
        if (node === this.endNode.previousSibling && node.nodeType === 3 /* Node.TEXT_NODE */ ) // If we only have a single text node between the markers, we can just
        // set its value, rather than replacing it.
        // TODO(justinfagnani): Can we just check if this.value is primitive?
        node.data = valueAsString;
        else this.__commitNode(document.createTextNode(valueAsString));
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof (0, $ab7394fbe791605c$export$6eecef7813f38266) && this.value.template === template) this.value.update(value.values);
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new (0, $ab7394fbe791605c$export$6eecef7813f38266)(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value){
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new $a0883e0a079a95ab$export$a354997aeda6e93(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) itemPart.appendIntoPart(this);
                else itemPart.insertAfterPart(itemParts[partIndex - 1]);
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        (0, $171cfc78f780daae$export$77f49a256021c8de)(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
}
class $a0883e0a079a95ab$export$b9df278b293d5b48 {
    constructor(element, name, strings){
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== "" || strings[1] !== "") throw new Error("Boolean attributes can only contain a single expression");
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $1f65399781f6270b$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $256f3772b55f662d$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.__pendingValue === (0, $256f3772b55f662d$export$9c068ae9cc5db4e8)) return;
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) this.element.setAttribute(this.name, "");
            else this.element.removeAttribute(this.name);
            this.value = value;
        }
        this.__pendingValue = (0, $256f3772b55f662d$export$9c068ae9cc5db4e8);
    }
}
class $a0883e0a079a95ab$export$2d7935a96ad7cb22 extends $a0883e0a079a95ab$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        super(element, name, strings);
        this.single = strings.length === 2 && strings[0] === "" && strings[1] === "";
    }
    _createPart() {
        return new $a0883e0a079a95ab$export$b78f5e1c476c794e(this);
    }
    _getValue() {
        if (this.single) return this.parts[0].value;
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
}
class $a0883e0a079a95ab$export$b78f5e1c476c794e extends $a0883e0a079a95ab$export$da9b3ca39c846561 {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let $a0883e0a079a95ab$var$eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(()=>{
    try {
        const options = {
            get capture () {
                $a0883e0a079a95ab$var$eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener("test", options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener("test", options, options);
    } catch (_e) {
    // event options not supported
    }
})();
class $a0883e0a079a95ab$export$b28e368652651bd7 {
    constructor(element, eventName, eventContext){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e)=>this.handleEvent(e);
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $1f65399781f6270b$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $256f3772b55f662d$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.__pendingValue === (0, $256f3772b55f662d$export$9c068ae9cc5db4e8)) return;
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null || oldListener != null && (newListener.capture !== oldListener.capture || newListener.once !== oldListener.once || newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        if (shouldAddListener) {
            this.__options = $a0883e0a079a95ab$var$getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = (0, $256f3772b55f662d$export$9c068ae9cc5db4e8);
    }
    handleEvent(event) {
        if (typeof this.value === "function") this.value.call(this.eventContext || this.element, event);
        else this.value.handleEvent(event);
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const $a0883e0a079a95ab$var$getOptions = (o)=>o && ($a0883e0a079a95ab$var$eventOptionsSupported ? {
        capture: o.capture,
        passive: o.passive,
        once: o.once
    } : o.capture);


class $ae3a33b16e3a058e$export$53a556099f0fa088 {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */ handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === ".") {
            const committer = new (0, $a0883e0a079a95ab$export$2d7935a96ad7cb22)(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === "@") return [
            new (0, $a0883e0a079a95ab$export$b28e368652651bd7)(element, name.slice(1), options.eventContext)
        ];
        if (prefix === "?") return [
            new (0, $a0883e0a079a95ab$export$b9df278b293d5b48)(element, name.slice(1), strings)
        ];
        const committer = new (0, $a0883e0a079a95ab$export$9ac9216e336e96d0)(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */ handleTextExpression(options) {
        return new (0, $a0883e0a079a95ab$export$a354997aeda6e93)(options);
    }
}
const $ae3a33b16e3a058e$export$608256e8e6650f65 = new $ae3a33b16e3a058e$export$53a556099f0fa088();







/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
function $29e3904baa8a49cb$export$ac8809ff023de002(result) {
    let templateCache = $29e3904baa8a49cb$export$f4a9a5e9f571ddee.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        $29e3904baa8a49cb$export$f4a9a5e9f571ddee.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) return template;
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join((0, $5aff7fadf259646c$export$ffc4d0086f1a4c9));
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new (0, $5aff7fadf259646c$export$14416b8d99d47caa)(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const $29e3904baa8a49cb$export$f4a9a5e9f571ddee = new Map();


const $892aaa600f832620$export$6e2410c1d27f06e7 = new WeakMap();
const $892aaa600f832620$export$b3890eb0ae9dca99 = (result, container, options)=>{
    let part = $892aaa600f832620$export$6e2410c1d27f06e7.get(container);
    if (part === undefined) {
        (0, $171cfc78f780daae$export$77f49a256021c8de)(container, container.firstChild);
        $892aaa600f832620$export$6e2410c1d27f06e7.set(container, part = new (0, $a0883e0a079a95ab$export$a354997aeda6e93)(Object.assign({
            templateFactory: $29e3904baa8a49cb$export$ac8809ff023de002
        }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};





// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== "undefined") (window["litHtmlVersions"] || (window["litHtmlVersions"] = [])).push("1.4.1");
const $c90bd6824c7bfa57$export$c0bb0b647f701bb5 = (strings, ...values)=>new (0, $99e433cdec05ae56$export$ce95ebd39b69fb27)(strings, values, "html", (0, $ae3a33b16e3a058e$export$608256e8e6650f65));
const $c90bd6824c7bfa57$export$7ed1367e7fa1ad68 = (strings, ...values)=>new (0, $99e433cdec05ae56$export$36e852975bbbeae0)(strings, values, "svg", (0, $ae3a33b16e3a058e$export$608256e8e6650f65));


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * Module to add shady DOM/shady CSS polyfill support to lit-html template
 * rendering. See the [[render]] method for details.
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ 
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
const $2761b5d4ff355f12$var$walkerNodeFilter = 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ ;
function $2761b5d4ff355f12$export$c372fec9bf14be6e(template, nodesToRemove) {
    const { element: { content: content }, parts: parts } = template;
    const walker = document.createTreeWalker(content, $2761b5d4ff355f12$var$walkerNodeFilter, null, false);
    let partIndex = $2761b5d4ff355f12$var$nextActiveIndexInTemplateParts(parts);
    let part = parts[partIndex];
    let nodeIndex = -1;
    let removeCount = 0;
    const nodesToRemoveInTemplate = [];
    let currentRemovingNode = null;
    while(walker.nextNode()){
        nodeIndex++;
        const node = walker.currentNode;
        // End removal if stepped past the removing node
        if (node.previousSibling === currentRemovingNode) currentRemovingNode = null;
        // A node to remove was found in the template
        if (nodesToRemove.has(node)) {
            nodesToRemoveInTemplate.push(node);
            // Track node we're removing
            if (currentRemovingNode === null) currentRemovingNode = node;
        }
        // When removing, increment count by which to adjust subsequent part indices
        if (currentRemovingNode !== null) removeCount++;
        while(part !== undefined && part.index === nodeIndex){
            // If part is in a removed node deactivate it by setting index to -1 or
            // adjust the index as needed.
            part.index = currentRemovingNode !== null ? -1 : part.index - removeCount;
            // go to the next active part.
            partIndex = $2761b5d4ff355f12$var$nextActiveIndexInTemplateParts(parts, partIndex);
            part = parts[partIndex];
        }
    }
    nodesToRemoveInTemplate.forEach((n)=>n.parentNode.removeChild(n));
}
const $2761b5d4ff355f12$var$countNodes = (node)=>{
    let count = node.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */  ? 0 : 1;
    const walker = document.createTreeWalker(node, $2761b5d4ff355f12$var$walkerNodeFilter, null, false);
    while(walker.nextNode())count++;
    return count;
};
const $2761b5d4ff355f12$var$nextActiveIndexInTemplateParts = (parts, startIndex = -1)=>{
    for(let i = startIndex + 1; i < parts.length; i++){
        const part = parts[i];
        if ((0, $5aff7fadf259646c$export$93919229d19012c8)(part)) return i;
    }
    return -1;
};
function $2761b5d4ff355f12$export$7a2b65ea46355476(template, node, refNode = null) {
    const { element: { content: content }, parts: parts } = template;
    // If there's no refNode, then put node at end of template.
    // No part indices need to be shifted in this case.
    if (refNode === null || refNode === undefined) {
        content.appendChild(node);
        return;
    }
    const walker = document.createTreeWalker(content, $2761b5d4ff355f12$var$walkerNodeFilter, null, false);
    let partIndex = $2761b5d4ff355f12$var$nextActiveIndexInTemplateParts(parts);
    let insertCount = 0;
    let walkerIndex = -1;
    while(walker.nextNode()){
        walkerIndex++;
        const walkerNode = walker.currentNode;
        if (walkerNode === refNode) {
            insertCount = $2761b5d4ff355f12$var$countNodes(node);
            refNode.parentNode.insertBefore(node, refNode);
        }
        while(partIndex !== -1 && parts[partIndex].index === walkerIndex){
            // If we've inserted the node, simply adjust all subsequent parts
            if (insertCount > 0) {
                while(partIndex !== -1){
                    parts[partIndex].index += insertCount;
                    partIndex = $2761b5d4ff355f12$var$nextActiveIndexInTemplateParts(parts, partIndex);
                }
                return;
            }
            partIndex = $2761b5d4ff355f12$var$nextActiveIndexInTemplateParts(parts, partIndex);
        }
    }
}







// Get a key to lookup in `templateCaches`.
const $36bba013f4fc4ae3$var$getTemplateCacheKey = (type, scopeName)=>`${type}--${scopeName}`;
let $36bba013f4fc4ae3$var$compatibleShadyCSSVersion = true;
if (typeof window.ShadyCSS === "undefined") $36bba013f4fc4ae3$var$compatibleShadyCSSVersion = false;
else if (typeof window.ShadyCSS.prepareTemplateDom === "undefined") {
    console.warn(`Incompatible ShadyCSS version detected. ` + `Please update to at least @webcomponents/webcomponentsjs@2.0.2 and ` + `@webcomponents/shadycss@1.3.1.`);
    $36bba013f4fc4ae3$var$compatibleShadyCSSVersion = false;
}
const $36bba013f4fc4ae3$export$307df51a48bd0a07 = (scopeName)=>(result)=>{
        const cacheKey = $36bba013f4fc4ae3$var$getTemplateCacheKey(result.type, scopeName);
        let templateCache = (0, $29e3904baa8a49cb$export$f4a9a5e9f571ddee).get(cacheKey);
        if (templateCache === undefined) {
            templateCache = {
                stringsArray: new WeakMap(),
                keyString: new Map()
            };
            (0, $29e3904baa8a49cb$export$f4a9a5e9f571ddee).set(cacheKey, templateCache);
        }
        let template = templateCache.stringsArray.get(result.strings);
        if (template !== undefined) return template;
        const key = result.strings.join((0, $5aff7fadf259646c$export$ffc4d0086f1a4c9));
        template = templateCache.keyString.get(key);
        if (template === undefined) {
            const element = result.getTemplateElement();
            if ($36bba013f4fc4ae3$var$compatibleShadyCSSVersion) window.ShadyCSS.prepareTemplateDom(element, scopeName);
            template = new (0, $5aff7fadf259646c$export$14416b8d99d47caa)(result, element);
            templateCache.keyString.set(key, template);
        }
        templateCache.stringsArray.set(result.strings, template);
        return template;
    };
const $36bba013f4fc4ae3$var$TEMPLATE_TYPES = [
    "html",
    "svg"
];
/**
 * Removes all style elements from Templates for the given scopeName.
 */ const $36bba013f4fc4ae3$var$removeStylesFromLitTemplates = (scopeName)=>{
    $36bba013f4fc4ae3$var$TEMPLATE_TYPES.forEach((type)=>{
        const templates = (0, $29e3904baa8a49cb$export$f4a9a5e9f571ddee).get($36bba013f4fc4ae3$var$getTemplateCacheKey(type, scopeName));
        if (templates !== undefined) templates.keyString.forEach((template)=>{
            const { element: { content: content } } = template;
            // IE 11 doesn't support the iterable param Set constructor
            const styles = new Set();
            Array.from(content.querySelectorAll("style")).forEach((s)=>{
                styles.add(s);
            });
            (0, $2761b5d4ff355f12$export$c372fec9bf14be6e)(template, styles);
        });
    });
};
const $36bba013f4fc4ae3$var$shadyRenderSet = new Set();
/**
 * For the given scope name, ensures that ShadyCSS style scoping is performed.
 * This is done just once per scope name so the fragment and template cannot
 * be modified.
 * (1) extracts styles from the rendered fragment and hands them to ShadyCSS
 * to be scoped and appended to the document
 * (2) removes style elements from all lit-html Templates for this scope name.
 *
 * Note, <style> elements can only be placed into templates for the
 * initial rendering of the scope. If <style> elements are included in templates
 * dynamically rendered to the scope (after the first scope render), they will
 * not be scoped and the <style> will be left in the template and rendered
 * output.
 */ const $36bba013f4fc4ae3$var$prepareTemplateStyles = (scopeName, renderedDOM, template)=>{
    $36bba013f4fc4ae3$var$shadyRenderSet.add(scopeName);
    // If `renderedDOM` is stamped from a Template, then we need to edit that
    // Template's underlying template element. Otherwise, we create one here
    // to give to ShadyCSS, which still requires one while scoping.
    const templateElement = !!template ? template.element : document.createElement("template");
    // Move styles out of rendered DOM and store.
    const styles = renderedDOM.querySelectorAll("style");
    const { length: length } = styles;
    // If there are no styles, skip unnecessary work
    if (length === 0) {
        // Ensure prepareTemplateStyles is called to support adding
        // styles via `prepareAdoptedCssText` since that requires that
        // `prepareTemplateStyles` is called.
        //
        // ShadyCSS will only update styles containing @apply in the template
        // given to `prepareTemplateStyles`. If no lit Template was given,
        // ShadyCSS will not be able to update uses of @apply in any relevant
        // template. However, this is not a problem because we only create the
        // template for the purpose of supporting `prepareAdoptedCssText`,
        // which doesn't support @apply at all.
        window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
        return;
    }
    const condensedStyle = document.createElement("style");
    // Collect styles into a single style. This helps us make sure ShadyCSS
    // manipulations will not prevent us from being able to fix up template
    // part indices.
    // NOTE: collecting styles is inefficient for browsers but ShadyCSS
    // currently does this anyway. When it does not, this should be changed.
    for(let i = 0; i < length; i++){
        const style = styles[i];
        style.parentNode.removeChild(style);
        condensedStyle.textContent += style.textContent;
    }
    // Remove styles from nested templates in this scope.
    $36bba013f4fc4ae3$var$removeStylesFromLitTemplates(scopeName);
    // And then put the condensed style into the "root" template passed in as
    // `template`.
    const content = templateElement.content;
    if (!!template) (0, $2761b5d4ff355f12$export$7a2b65ea46355476)(template, condensedStyle, content.firstChild);
    else content.insertBefore(condensedStyle, content.firstChild);
    // Note, it's important that ShadyCSS gets the template that `lit-html`
    // will actually render so that it can update the style inside when
    // needed (e.g. @apply native Shadow DOM case).
    window.ShadyCSS.prepareTemplateStyles(templateElement, scopeName);
    const style = content.querySelector("style");
    if (window.ShadyCSS.nativeShadow && style !== null) // When in native Shadow DOM, ensure the style created by ShadyCSS is
    // included in initially rendered output (`renderedDOM`).
    renderedDOM.insertBefore(style.cloneNode(true), renderedDOM.firstChild);
    else if (!!template) {
        // When no style is left in the template, parts will be broken as a
        // result. To fix this, we put back the style node ShadyCSS removed
        // and then tell lit to remove that node from the template.
        // There can be no style in the template in 2 cases (1) when Shady DOM
        // is in use, ShadyCSS removes all styles, (2) when native Shadow DOM
        // is in use ShadyCSS removes the style if it contains no content.
        // NOTE, ShadyCSS creates its own style so we can safely add/remove
        // `condensedStyle` here.
        content.insertBefore(condensedStyle, content.firstChild);
        const removes = new Set();
        removes.add(condensedStyle);
        (0, $2761b5d4ff355f12$export$c372fec9bf14be6e)(template, removes);
    }
};
const $36bba013f4fc4ae3$export$b3890eb0ae9dca99 = (result, container, options)=>{
    if (!options || typeof options !== "object" || !options.scopeName) throw new Error("The `scopeName` option is required.");
    const scopeName = options.scopeName;
    const hasRendered = (0, $892aaa600f832620$export$6e2410c1d27f06e7).has(container);
    const needsScoping = $36bba013f4fc4ae3$var$compatibleShadyCSSVersion && container.nodeType === 11 /* Node.DOCUMENT_FRAGMENT_NODE */  && !!container.host;
    // Handle first render to a scope specially...
    const firstScopeRender = needsScoping && !$36bba013f4fc4ae3$var$shadyRenderSet.has(scopeName);
    // On first scope render, render into a fragment; this cannot be a single
    // fragment that is reused since nested renders can occur synchronously.
    const renderContainer = firstScopeRender ? document.createDocumentFragment() : container;
    (0, $892aaa600f832620$export$b3890eb0ae9dca99)(result, renderContainer, Object.assign({
        templateFactory: $36bba013f4fc4ae3$export$307df51a48bd0a07(scopeName)
    }, options));
    // When performing first scope render,
    // (1) We've rendered into a fragment so that there's a chance to
    // `prepareTemplateStyles` before sub-elements hit the DOM
    // (which might cause them to render based on a common pattern of
    // rendering in a custom element's `connectedCallback`);
    // (2) Scope the template with ShadyCSS one time only for this scope.
    // (3) Render the fragment into the container and make sure the
    // container knows its `part` is the one we just rendered. This ensures
    // DOM will be re-used on subsequent renders.
    if (firstScopeRender) {
        const part = (0, $892aaa600f832620$export$6e2410c1d27f06e7).get(renderContainer);
        (0, $892aaa600f832620$export$6e2410c1d27f06e7).delete(renderContainer);
        // ShadyCSS might have style sheets (e.g. from `prepareAdoptedCssText`)
        // that should apply to `renderContainer` even if the rendered value is
        // not a TemplateInstance. However, it will only insert scoped styles
        // into the document if `prepareTemplateStyles` has already been called
        // for the given scope name.
        const template = part.value instanceof (0, $ab7394fbe791605c$export$6eecef7813f38266) ? part.value.template : undefined;
        $36bba013f4fc4ae3$var$prepareTemplateStyles(scopeName, renderContainer, template);
        (0, $171cfc78f780daae$export$77f49a256021c8de)(container, container.firstChild);
        container.appendChild(renderContainer);
        (0, $892aaa600f832620$export$6e2410c1d27f06e7).set(container, part);
    }
    // After elements have hit the DOM, update styling if this is the
    // initial render to this container.
    // This is needed whenever dynamic changes are made so it would be
    // safest to do every render; however, this would regress performance
    // so we leave it up to the user to call `ShadyCSS.styleElement`
    // for dynamic changes.
    if (!hasRendered && needsScoping) window.ShadyCSS.styleElement(container.host);
};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ var $e7f6989cbc50fb08$var$_a;
/**
 * When using Closure Compiler, JSCompiler_renameProperty(property, object) is
 * replaced at compile time by the munged name for object[property]. We cannot
 * alias this function, so we have to use a small shim that has the same
 * behavior when not compiling.
 */ window.JSCompiler_renameProperty = (prop, _obj)=>prop;
const $e7f6989cbc50fb08$export$7312b35fbf521afb = {
    toAttribute (value, type) {
        switch(type){
            case Boolean:
                return value ? "" : null;
            case Object:
            case Array:
                // if the value is `null` or `undefined` pass this through
                // to allow removing/no change behavior.
                return value == null ? value : JSON.stringify(value);
        }
        return value;
    },
    fromAttribute (value, type) {
        switch(type){
            case Boolean:
                return value !== null;
            case Number:
                return value === null ? null : Number(value);
            case Object:
            case Array:
                return JSON.parse(value);
        }
        return value;
    }
};
const $e7f6989cbc50fb08$export$53a6892c50694894 = (value, old)=>{
    // This ensures (old==NaN, value==NaN) always returns false
    return old !== value && (old === old || value === value);
};
const $e7f6989cbc50fb08$var$defaultPropertyDeclaration = {
    attribute: true,
    type: String,
    converter: $e7f6989cbc50fb08$export$7312b35fbf521afb,
    reflect: false,
    hasChanged: $e7f6989cbc50fb08$export$53a6892c50694894
};
const $e7f6989cbc50fb08$var$microtaskPromise = Promise.resolve(true);
const $e7f6989cbc50fb08$var$STATE_HAS_UPDATED = 1;
const $e7f6989cbc50fb08$var$STATE_UPDATE_REQUESTED = 4;
const $e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_ATTRIBUTE = 8;
const $e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_PROPERTY = 16;
const $e7f6989cbc50fb08$var$STATE_HAS_CONNECTED = 32;
/**
 * The Closure JS Compiler doesn't currently have good support for static
 * property semantics where "this" is dynamic (e.g.
 * https://github.com/google/closure-compiler/issues/3177 and others) so we use
 * this hack to bypass any rewriting by the compiler.
 */ const $e7f6989cbc50fb08$var$finalized = "finalized";
class $e7f6989cbc50fb08$export$8bf27daf9e8907c9 extends HTMLElement {
    constructor(){
        super();
        this._updateState = 0;
        this._instanceProperties = undefined;
        this._updatePromise = $e7f6989cbc50fb08$var$microtaskPromise;
        this._hasConnectedResolver = undefined;
        /**
         * Map with keys for any properties that have changed since the last
         * update cycle with previous values.
         */ this._changedProperties = new Map();
        /**
         * Map with keys of properties that should be reflected when updated.
         */ this._reflectingProperties = undefined;
        this.initialize();
    }
    /**
     * Returns a list of attributes corresponding to the registered properties.
     * @nocollapse
     */ static get observedAttributes() {
        // note: piggy backing on this to ensure we're finalized.
        this.finalize();
        const attributes = [];
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this._classProperties.forEach((v, p)=>{
            const attr = this._attributeNameForProperty(p, v);
            if (attr !== undefined) {
                this._attributeToPropertyMap.set(attr, p);
                attributes.push(attr);
            }
        });
        return attributes;
    }
    /**
     * Ensures the private `_classProperties` property metadata is created.
     * In addition to `finalize` this is also called in `createProperty` to
     * ensure the `@property` decorator can add property metadata.
     */ /** @nocollapse */ static _ensureClassProperties() {
        // ensure private storage for property declarations.
        if (!this.hasOwnProperty(JSCompiler_renameProperty("_classProperties", this))) {
            this._classProperties = new Map();
            // NOTE: Workaround IE11 not supporting Map constructor argument.
            const superProperties = Object.getPrototypeOf(this)._classProperties;
            if (superProperties !== undefined) superProperties.forEach((v, k)=>this._classProperties.set(k, v));
        }
    }
    /**
     * Creates a property accessor on the element prototype if one does not exist.
     * The property setter calls the property's `hasChanged` property option
     * or uses a strict identity check to determine whether or not to request
     * an update.
     * @nocollapse
     */ static createProperty(name, options = $e7f6989cbc50fb08$var$defaultPropertyDeclaration) {
        // Note, since this can be called by the `@property` decorator which
        // is called before `finalize`, we ensure storage exists for property
        // metadata.
        this._ensureClassProperties();
        this._classProperties.set(name, options);
        // Do not generate an accessor if the prototype already has one, since
        // it would be lost otherwise and that would never be the user's intention;
        // Instead, we expect users to call `requestUpdate` themselves from
        // user-defined accessors. Note that if the super has an accessor we will
        // still overwrite it
        if (options.noAccessor || this.prototype.hasOwnProperty(name)) return;
        const key = typeof name === "symbol" ? Symbol() : `__${name}`;
        Object.defineProperty(this.prototype, name, {
            // tslint:disable-next-line:no-any no symbol in index
            get () {
                return this[key];
            },
            set (value) {
                const oldValue = this[name];
                this[key] = value;
                this._requestUpdate(name, oldValue);
            },
            configurable: true,
            enumerable: true
        });
    }
    /**
     * Creates property accessors for registered properties and ensures
     * any superclasses are also finalized.
     * @nocollapse
     */ static finalize() {
        // finalize any superclasses
        const superCtor = Object.getPrototypeOf(this);
        if (!superCtor.hasOwnProperty($e7f6989cbc50fb08$var$finalized)) superCtor.finalize();
        this[$e7f6989cbc50fb08$var$finalized] = true;
        this._ensureClassProperties();
        // initialize Map populated in observedAttributes
        this._attributeToPropertyMap = new Map();
        // make any properties
        // Note, only process "own" properties since this element will inherit
        // any properties defined on the superClass, and finalization ensures
        // the entire prototype chain is finalized.
        if (this.hasOwnProperty(JSCompiler_renameProperty("properties", this))) {
            const props = this.properties;
            // support symbols in properties (IE11 does not support this)
            const propKeys = [
                ...Object.getOwnPropertyNames(props),
                ...typeof Object.getOwnPropertySymbols === "function" ? Object.getOwnPropertySymbols(props) : []
            ];
            // This for/of is ok because propKeys is an array
            for (const p of propKeys)// note, use of `any` is due to TypeSript lack of support for symbol in
            // index types
            // tslint:disable-next-line:no-any no symbol in index
            this.createProperty(p, props[p]);
        }
    }
    /**
     * Returns the property name for the given attribute `name`.
     * @nocollapse
     */ static _attributeNameForProperty(name, options) {
        const attribute = options.attribute;
        return attribute === false ? undefined : typeof attribute === "string" ? attribute : typeof name === "string" ? name.toLowerCase() : undefined;
    }
    /**
     * Returns true if a property should request an update.
     * Called when a property value is set and uses the `hasChanged`
     * option for the property if present or a strict identity check.
     * @nocollapse
     */ static _valueHasChanged(value, old, hasChanged = $e7f6989cbc50fb08$export$53a6892c50694894) {
        return hasChanged(value, old);
    }
    /**
     * Returns the property value for the given attribute value.
     * Called via the `attributeChangedCallback` and uses the property's
     * `converter` or `converter.fromAttribute` property option.
     * @nocollapse
     */ static _propertyValueFromAttribute(value, options) {
        const type = options.type;
        const converter = options.converter || $e7f6989cbc50fb08$export$7312b35fbf521afb;
        const fromAttribute = typeof converter === "function" ? converter : converter.fromAttribute;
        return fromAttribute ? fromAttribute(value, type) : value;
    }
    /**
     * Returns the attribute value for the given property value. If this
     * returns undefined, the property will *not* be reflected to an attribute.
     * If this returns null, the attribute will be removed, otherwise the
     * attribute will be set to the value.
     * This uses the property's `reflect` and `type.toAttribute` property options.
     * @nocollapse
     */ static _propertyValueToAttribute(value, options) {
        if (options.reflect === undefined) return;
        const type = options.type;
        const converter = options.converter;
        const toAttribute = converter && converter.toAttribute || $e7f6989cbc50fb08$export$7312b35fbf521afb.toAttribute;
        return toAttribute(value, type);
    }
    /**
     * Performs element initialization. By default captures any pre-set values for
     * registered properties.
     */ initialize() {
        this._saveInstanceProperties();
        // ensures first update will be caught by an early access of
        // `updateComplete`
        this._requestUpdate();
    }
    /**
     * Fixes any properties set on the instance before upgrade time.
     * Otherwise these would shadow the accessor and break these properties.
     * The properties are stored in a Map which is played back after the
     * constructor runs. Note, on very old versions of Safari (<=9) or Chrome
     * (<=41), properties created for native platform properties like (`id` or
     * `name`) may not have default values set in the element constructor. On
     * these browsers native properties appear on instances and therefore their
     * default value will overwrite any element default (e.g. if the element sets
     * this.id = 'id' in the constructor, the 'id' will become '' since this is
     * the native platform default).
     */ _saveInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        this.constructor._classProperties.forEach((_v, p)=>{
            if (this.hasOwnProperty(p)) {
                const value = this[p];
                delete this[p];
                if (!this._instanceProperties) this._instanceProperties = new Map();
                this._instanceProperties.set(p, value);
            }
        });
    }
    /**
     * Applies previously saved instance properties.
     */ _applyInstanceProperties() {
        // Use forEach so this works even if for/of loops are compiled to for loops
        // expecting arrays
        // tslint:disable-next-line:no-any
        this._instanceProperties.forEach((v, p)=>this[p] = v);
        this._instanceProperties = undefined;
    }
    connectedCallback() {
        this._updateState = this._updateState | $e7f6989cbc50fb08$var$STATE_HAS_CONNECTED;
        // Ensure first connection completes an update. Updates cannot complete
        // before connection and if one is pending connection the
        // `_hasConnectionResolver` will exist. If so, resolve it to complete the
        // update, otherwise requestUpdate.
        if (this._hasConnectedResolver) {
            this._hasConnectedResolver();
            this._hasConnectedResolver = undefined;
        }
    }
    /**
     * Allows for `super.disconnectedCallback()` in extensions while
     * reserving the possibility of making non-breaking feature additions
     * when disconnecting at some point in the future.
     */ disconnectedCallback() {}
    /**
     * Synchronizes property values when attributes change.
     */ attributeChangedCallback(name, old, value) {
        if (old !== value) this._attributeToProperty(name, value);
    }
    _propertyToAttribute(name, value, options = $e7f6989cbc50fb08$var$defaultPropertyDeclaration) {
        const ctor = this.constructor;
        const attr = ctor._attributeNameForProperty(name, options);
        if (attr !== undefined) {
            const attrValue = ctor._propertyValueToAttribute(value, options);
            // an undefined value does not change the attribute.
            if (attrValue === undefined) return;
            // Track if the property is being reflected to avoid
            // setting the property again via `attributeChangedCallback`. Note:
            // 1. this takes advantage of the fact that the callback is synchronous.
            // 2. will behave incorrectly if multiple attributes are in the reaction
            // stack at time of calling. However, since we process attributes
            // in `update` this should not be possible (or an extreme corner case
            // that we'd like to discover).
            // mark state reflecting
            this._updateState = this._updateState | $e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_ATTRIBUTE;
            if (attrValue == null) this.removeAttribute(attr);
            else this.setAttribute(attr, attrValue);
            // mark state not reflecting
            this._updateState = this._updateState & ~$e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_ATTRIBUTE;
        }
    }
    _attributeToProperty(name, value) {
        // Use tracking info to avoid deserializing attribute value if it was
        // just set from a property setter.
        if (this._updateState & $e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_ATTRIBUTE) return;
        const ctor = this.constructor;
        const propName = ctor._attributeToPropertyMap.get(name);
        if (propName !== undefined) {
            const options = ctor._classProperties.get(propName) || $e7f6989cbc50fb08$var$defaultPropertyDeclaration;
            // mark state reflecting
            this._updateState = this._updateState | $e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_PROPERTY;
            this[propName] = // tslint:disable-next-line:no-any
            ctor._propertyValueFromAttribute(value, options);
            // mark state not reflecting
            this._updateState = this._updateState & ~$e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_PROPERTY;
        }
    }
    /**
     * This private version of `requestUpdate` does not access or return the
     * `updateComplete` promise. This promise can be overridden and is therefore
     * not free to access.
     */ _requestUpdate(name, oldValue) {
        let shouldRequestUpdate = true;
        // If we have a property key, perform property update steps.
        if (name !== undefined) {
            const ctor = this.constructor;
            const options = ctor._classProperties.get(name) || $e7f6989cbc50fb08$var$defaultPropertyDeclaration;
            if (ctor._valueHasChanged(this[name], oldValue, options.hasChanged)) {
                if (!this._changedProperties.has(name)) this._changedProperties.set(name, oldValue);
                // Add to reflecting properties set.
                // Note, it's important that every change has a chance to add the
                // property to `_reflectingProperties`. This ensures setting
                // attribute + property reflects correctly.
                if (options.reflect === true && !(this._updateState & $e7f6989cbc50fb08$var$STATE_IS_REFLECTING_TO_PROPERTY)) {
                    if (this._reflectingProperties === undefined) this._reflectingProperties = new Map();
                    this._reflectingProperties.set(name, options);
                }
            } else // Abort the request if the property should not be considered changed.
            shouldRequestUpdate = false;
        }
        if (!this._hasRequestedUpdate && shouldRequestUpdate) this._enqueueUpdate();
    }
    /**
     * Requests an update which is processed asynchronously. This should
     * be called when an element should update based on some state not triggered
     * by setting a property. In this case, pass no arguments. It should also be
     * called when manually implementing a property setter. In this case, pass the
     * property `name` and `oldValue` to ensure that any configured property
     * options are honored. Returns the `updateComplete` Promise which is resolved
     * when the update completes.
     *
     * @param name {PropertyKey} (optional) name of requesting property
     * @param oldValue {any} (optional) old value of requesting property
     * @returns {Promise} A Promise that is resolved when the update completes.
     */ requestUpdate(name, oldValue) {
        this._requestUpdate(name, oldValue);
        return this.updateComplete;
    }
    /**
     * Sets up the element to asynchronously update.
     */ async _enqueueUpdate() {
        // Mark state updating...
        this._updateState = this._updateState | $e7f6989cbc50fb08$var$STATE_UPDATE_REQUESTED;
        let resolve;
        let reject;
        const previousUpdatePromise = this._updatePromise;
        this._updatePromise = new Promise((res, rej)=>{
            resolve = res;
            reject = rej;
        });
        try {
            // Ensure any previous update has resolved before updating.
            // This `await` also ensures that property changes are batched.
            await previousUpdatePromise;
        } catch (e) {
        // Ignore any previous errors. We only care that the previous cycle is
        // done. Any error should have been handled in the previous update.
        }
        // Make sure the element has connected before updating.
        if (!this._hasConnected) await new Promise((res)=>this._hasConnectedResolver = res);
        try {
            const result = this.performUpdate();
            // If `performUpdate` returns a Promise, we await it. This is done to
            // enable coordinating updates with a scheduler. Note, the result is
            // checked to avoid delaying an additional microtask unless we need to.
            if (result != null) await result;
        } catch (e) {
            reject(e);
        }
        resolve(!this._hasRequestedUpdate);
    }
    get _hasConnected() {
        return this._updateState & $e7f6989cbc50fb08$var$STATE_HAS_CONNECTED;
    }
    get _hasRequestedUpdate() {
        return this._updateState & $e7f6989cbc50fb08$var$STATE_UPDATE_REQUESTED;
    }
    get hasUpdated() {
        return this._updateState & $e7f6989cbc50fb08$var$STATE_HAS_UPDATED;
    }
    /**
     * Performs an element update. Note, if an exception is thrown during the
     * update, `firstUpdated` and `updated` will not be called.
     *
     * You can override this method to change the timing of updates. If this
     * method is overridden, `super.performUpdate()` must be called.
     *
     * For instance, to schedule updates to occur just before the next frame:
     *
     * ```
     * protected async performUpdate(): Promise<unknown> {
     *   await new Promise((resolve) => requestAnimationFrame(() => resolve()));
     *   super.performUpdate();
     * }
     * ```
     */ performUpdate() {
        // Mixin instance properties once, if they exist.
        if (this._instanceProperties) this._applyInstanceProperties();
        let shouldUpdate = false;
        const changedProperties = this._changedProperties;
        try {
            shouldUpdate = this.shouldUpdate(changedProperties);
            if (shouldUpdate) this.update(changedProperties);
        } catch (e) {
            // Prevent `firstUpdated` and `updated` from running when there's an
            // update exception.
            shouldUpdate = false;
            throw e;
        } finally{
            // Ensure element can accept additional updates after an exception.
            this._markUpdated();
        }
        if (shouldUpdate) {
            if (!(this._updateState & $e7f6989cbc50fb08$var$STATE_HAS_UPDATED)) {
                this._updateState = this._updateState | $e7f6989cbc50fb08$var$STATE_HAS_UPDATED;
                this.firstUpdated(changedProperties);
            }
            this.updated(changedProperties);
        }
    }
    _markUpdated() {
        this._changedProperties = new Map();
        this._updateState = this._updateState & ~$e7f6989cbc50fb08$var$STATE_UPDATE_REQUESTED;
    }
    /**
     * Returns a Promise that resolves when the element has completed updating.
     * The Promise value is a boolean that is `true` if the element completed the
     * update without triggering another update. The Promise result is `false` if
     * a property was set inside `updated()`. If the Promise is rejected, an
     * exception was thrown during the update.
     *
     * To await additional asynchronous work, override the `_getUpdateComplete`
     * method. For example, it is sometimes useful to await a rendered element
     * before fulfilling this Promise. To do this, first await
     * `super._getUpdateComplete()`, then any subsequent state.
     *
     * @returns {Promise} The Promise returns a boolean that indicates if the
     * update resolved without triggering another update.
     */ get updateComplete() {
        return this._getUpdateComplete();
    }
    /**
     * Override point for the `updateComplete` promise.
     *
     * It is not safe to override the `updateComplete` getter directly due to a
     * limitation in TypeScript which means it is not possible to call a
     * superclass getter (e.g. `super.updateComplete.then(...)`) when the target
     * language is ES5 (https://github.com/microsoft/TypeScript/issues/338).
     * This method should be overridden instead. For example:
     *
     *   class MyElement extends LitElement {
     *     async _getUpdateComplete() {
     *       await super._getUpdateComplete();
     *       await this._myChild.updateComplete;
     *     }
     *   }
     */ _getUpdateComplete() {
        return this._updatePromise;
    }
    /**
     * Controls whether or not `update` should be called when the element requests
     * an update. By default, this method always returns `true`, but this can be
     * customized to control when to update.
     *
     * * @param _changedProperties Map of changed properties with old values
     */ shouldUpdate(_changedProperties) {
        return true;
    }
    /**
     * Updates the element. This method reflects property values to attributes.
     * It can be overridden to render and keep updated element DOM.
     * Setting properties inside this method will *not* trigger
     * another update.
     *
     * * @param _changedProperties Map of changed properties with old values
     */ update(_changedProperties) {
        if (this._reflectingProperties !== undefined && this._reflectingProperties.size > 0) {
            // Use forEach so this works even if for/of loops are compiled to for
            // loops expecting arrays
            this._reflectingProperties.forEach((v, k)=>this._propertyToAttribute(k, this[k], v));
            this._reflectingProperties = undefined;
        }
    }
    /**
     * Invoked whenever the element is updated. Implement to perform
     * post-updating tasks via DOM APIs, for example, focusing an element.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * * @param _changedProperties Map of changed properties with old values
     */ updated(_changedProperties) {}
    /**
     * Invoked when the element is first updated. Implement to perform one time
     * work on the element after update.
     *
     * Setting properties inside this method will trigger the element to update
     * again after this update cycle completes.
     *
     * * @param _changedProperties Map of changed properties with old values
     */ firstUpdated(_changedProperties) {}
}
$e7f6989cbc50fb08$var$_a = $e7f6989cbc50fb08$var$finalized;
/**
 * Marks class as having finished creating properties.
 */ $e7f6989cbc50fb08$export$8bf27daf9e8907c9[$e7f6989cbc50fb08$var$_a] = true;


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $98c1f98960b570ee$var$legacyCustomElement = (tagName, clazz)=>{
    window.customElements.define(tagName, clazz);
    // Cast as any because TS doesn't recognize the return type as being a
    // subtype of the decorated class when clazz is typed as
    // `Constructor<HTMLElement>` for some reason.
    // `Constructor<HTMLElement>` is helpful to make sure the decorator is
    // applied to elements however.
    // tslint:disable-next-line:no-any
    return clazz;
};
const $98c1f98960b570ee$var$standardCustomElement = (tagName, descriptor)=>{
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        // This callback is called once the class is otherwise fully defined
        finisher (clazz) {
            window.customElements.define(tagName, clazz);
        }
    };
};
const $98c1f98960b570ee$export$da64fc29f17f9d0e = (tagName)=>(classOrDescriptor)=>typeof classOrDescriptor === "function" ? $98c1f98960b570ee$var$legacyCustomElement(tagName, classOrDescriptor) : $98c1f98960b570ee$var$standardCustomElement(tagName, classOrDescriptor);
const $98c1f98960b570ee$var$standardProperty = (options, element)=>{
    // When decorating an accessor, pass it through and add property metadata.
    // Note, the `hasOwnProperty` check in `createProperty` ensures we don't
    // stomp over the user's accessor.
    if (element.kind === "method" && element.descriptor && !("value" in element.descriptor)) return Object.assign({}, element, {
        finisher (clazz) {
            clazz.createProperty(element.key, options);
        }
    });
    else // createProperty() takes care of defining the property, but we still
    // must return some kind of descriptor, so return a descriptor for an
    // unused prototype field. The finisher calls createProperty().
    return {
        kind: "field",
        key: Symbol(),
        placement: "own",
        descriptor: {},
        // When @babel/plugin-proposal-decorators implements initializers,
        // do this instead of the initializer below. See:
        // https://github.com/babel/babel/issues/9260 extras: [
        //   {
        //     kind: 'initializer',
        //     placement: 'own',
        //     initializer: descriptor.initializer,
        //   }
        // ],
        initializer () {
            if (typeof element.initializer === "function") this[element.key] = element.initializer.call(this);
        },
        finisher (clazz) {
            clazz.createProperty(element.key, options);
        }
    };
};
const $98c1f98960b570ee$var$legacyProperty = (options, proto, name)=>{
    proto.constructor.createProperty(name, options);
};
function $98c1f98960b570ee$export$d541bacb2bda4494(options) {
    // tslint:disable-next-line:no-any decorator
    return (protoOrDescriptor, name)=>name !== undefined ? $98c1f98960b570ee$var$legacyProperty(options, protoOrDescriptor, name) : $98c1f98960b570ee$var$standardProperty(options, protoOrDescriptor);
}
function $98c1f98960b570ee$export$2fa187e846a241c4(selector) {
    return (protoOrDescriptor, // tslint:disable-next-line:no-any decorator
    name)=>{
        const descriptor = {
            get () {
                return this.renderRoot.querySelector(selector);
            },
            enumerable: true,
            configurable: true
        };
        return name !== undefined ? $98c1f98960b570ee$var$legacyQuery(descriptor, protoOrDescriptor, name) : $98c1f98960b570ee$var$standardQuery(descriptor, protoOrDescriptor);
    };
}
function $98c1f98960b570ee$export$dcd0d083aa86c355(selector) {
    return (protoOrDescriptor, // tslint:disable-next-line:no-any decorator
    name)=>{
        const descriptor = {
            get () {
                return this.renderRoot.querySelectorAll(selector);
            },
            enumerable: true,
            configurable: true
        };
        return name !== undefined ? $98c1f98960b570ee$var$legacyQuery(descriptor, protoOrDescriptor, name) : $98c1f98960b570ee$var$standardQuery(descriptor, protoOrDescriptor);
    };
}
const $98c1f98960b570ee$var$legacyQuery = (descriptor, proto, name)=>{
    Object.defineProperty(proto, name, descriptor);
};
const $98c1f98960b570ee$var$standardQuery = (descriptor, element)=>({
        kind: "method",
        placement: "prototype",
        key: element.key,
        descriptor: descriptor
    });
const $98c1f98960b570ee$var$standardEventOptions = (options, element)=>{
    return Object.assign({}, element, {
        finisher (clazz) {
            Object.assign(clazz.prototype[element.key], options);
        }
    });
};
const $98c1f98960b570ee$var$legacyEventOptions = // tslint:disable-next-line:no-any legacy decorator
(options, proto, name)=>{
    Object.assign(proto[name], options);
};
const $98c1f98960b570ee$export$b2b799818fbabcf3 = (options)=>// Return value typed as any to prevent TypeScript from complaining that
    // standard decorator function signature does not match TypeScript decorator
    // signature
    // TODO(kschaaf): unclear why it was only failing on this decorator and not
    // the others
    (protoOrDescriptor, name)=>name !== undefined ? $98c1f98960b570ee$var$legacyEventOptions(options, protoOrDescriptor, name) : $98c1f98960b570ee$var$standardEventOptions(options, protoOrDescriptor);



/**
@license
Copyright (c) 2019 The Polymer Project Authors. All rights reserved.
This code may only be used under the BSD style license found at
http://polymer.github.io/LICENSE.txt The complete set of authors may be found at
http://polymer.github.io/AUTHORS.txt The complete set of contributors may be
found at http://polymer.github.io/CONTRIBUTORS.txt Code distributed by Google as
part of the polymer project is also subject to an additional IP rights grant
found at http://polymer.github.io/PATENTS.txt
*/ const $d55c951de13cf645$export$b4d10f6001c083c2 = "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
const $d55c951de13cf645$var$constructionToken = Symbol();
class $d55c951de13cf645$export$505d1e8739bad805 {
    constructor(cssText, safeToken){
        if (safeToken !== $d55c951de13cf645$var$constructionToken) throw new Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = cssText;
    }
    // Note, this is a getter so that it's lazy. In practice, this means
    // stylesheets are not created until the first element instance is made.
    get styleSheet() {
        if (this._styleSheet === undefined) {
            // Note, if `adoptedStyleSheets` is supported then we assume CSSStyleSheet
            // is constructable.
            if ($d55c951de13cf645$export$b4d10f6001c083c2) {
                this._styleSheet = new CSSStyleSheet();
                this._styleSheet.replaceSync(this.cssText);
            } else this._styleSheet = null;
        }
        return this._styleSheet;
    }
    toString() {
        return this.cssText;
    }
}
const $d55c951de13cf645$export$8d80f9cac07cdb3 = (value)=>{
    return new $d55c951de13cf645$export$505d1e8739bad805(String(value), $d55c951de13cf645$var$constructionToken);
};
const $d55c951de13cf645$var$textFromCSSResult = (value)=>{
    if (value instanceof $d55c951de13cf645$export$505d1e8739bad805) return value.cssText;
    else if (typeof value === "number") return value;
    else throw new Error(`Value passed to 'css' function must be a 'css' function result: ${value}. Use 'unsafeCSS' to pass non-literal values, but
            take care to ensure page security.`);
};
const $d55c951de13cf645$export$dbf350e5966cf602 = (strings, ...values)=>{
    const cssText = values.reduce((acc, v, idx)=>acc + $d55c951de13cf645$var$textFromCSSResult(v) + strings[idx + 1], strings[0]);
    return new $d55c951de13cf645$export$505d1e8739bad805(cssText, $d55c951de13cf645$var$constructionToken);
};


// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for LitElement usage.
// TODO(justinfagnani): inject version number at build time
(window["litElementVersions"] || (window["litElementVersions"] = [])).push("2.2.1");
/**
 * Minimal implementation of Array.prototype.flat
 * @param arr the array to flatten
 * @param result the accumlated result
 */ function $fe586ba0757c37f7$var$arrayFlat(styles, result = []) {
    for(let i = 0, length = styles.length; i < length; i++){
        const value = styles[i];
        if (Array.isArray(value)) $fe586ba0757c37f7$var$arrayFlat(value, result);
        else result.push(value);
    }
    return result;
}
/** Deeply flattens styles array. Uses native flat if available. */ const $fe586ba0757c37f7$var$flattenStyles = (styles)=>styles.flat ? styles.flat(Infinity) : $fe586ba0757c37f7$var$arrayFlat(styles);
class $fe586ba0757c37f7$export$3f2f9f5909897157 extends (0, $e7f6989cbc50fb08$export$8bf27daf9e8907c9) {
    /** @nocollapse */ static finalize() {
        // The Closure JS Compiler does not always preserve the correct "this"
        // when calling static super methods (b/137460243), so explicitly bind.
        super.finalize.call(this);
        // Prepare styling that is stamped at first render time. Styling
        // is built from user provided `styles` or is inherited from the superclass.
        this._styles = this.hasOwnProperty(JSCompiler_renameProperty("styles", this)) ? this._getUniqueStyles() : this._styles || [];
    }
    /** @nocollapse */ static _getUniqueStyles() {
        // Take care not to call `this.styles` multiple times since this generates
        // new CSSResults each time.
        // TODO(sorvell): Since we do not cache CSSResults by input, any
        // shared styles will generate new stylesheet objects, which is wasteful.
        // This should be addressed when a browser ships constructable
        // stylesheets.
        const userStyles = this.styles;
        const styles = [];
        if (Array.isArray(userStyles)) {
            const flatStyles = $fe586ba0757c37f7$var$flattenStyles(userStyles);
            // As a performance optimization to avoid duplicated styling that can
            // occur especially when composing via subclassing, de-duplicate styles
            // preserving the last item in the list. The last item is kept to
            // try to preserve cascade order with the assumption that it's most
            // important that last added styles override previous styles.
            const styleSet = flatStyles.reduceRight((set, s)=>{
                set.add(s);
                // on IE set.add does not return the set.
                return set;
            }, new Set());
            // Array.from does not work on Set in IE
            styleSet.forEach((v)=>styles.unshift(v));
        } else if (userStyles) styles.push(userStyles);
        return styles;
    }
    /**
     * Performs element initialization. By default this calls `createRenderRoot`
     * to create the element `renderRoot` node and captures any pre-set values for
     * registered properties.
     */ initialize() {
        super.initialize();
        this.renderRoot = this.createRenderRoot();
        // Note, if renderRoot is not a shadowRoot, styles would/could apply to the
        // element's getRootNode(). While this could be done, we're choosing not to
        // support this now since it would require different logic around de-duping.
        if (window.ShadowRoot && this.renderRoot instanceof window.ShadowRoot) this.adoptStyles();
    }
    /**
     * Returns the node into which the element should render and by default
     * creates and returns an open shadowRoot. Implement to customize where the
     * element's DOM is rendered. For example, to render into the element's
     * childNodes, return `this`.
     * @returns {Element|DocumentFragment} Returns a node into which to render.
     */ createRenderRoot() {
        return this.attachShadow({
            mode: "open"
        });
    }
    /**
     * Applies styling to the element shadowRoot using the `static get styles`
     * property. Styling will apply using `shadowRoot.adoptedStyleSheets` where
     * available and will fallback otherwise. When Shadow DOM is polyfilled,
     * ShadyCSS scopes styles and adds them to the document. When Shadow DOM
     * is available but `adoptedStyleSheets` is not, styles are appended to the
     * end of the `shadowRoot` to [mimic spec
     * behavior](https://wicg.github.io/construct-stylesheets/#using-constructed-stylesheets).
     */ adoptStyles() {
        const styles = this.constructor._styles;
        if (styles.length === 0) return;
        // There are three separate cases here based on Shadow DOM support.
        // (1) shadowRoot polyfilled: use ShadyCSS
        // (2) shadowRoot.adoptedStyleSheets available: use it.
        // (3) shadowRoot.adoptedStyleSheets polyfilled: append styles after
        // rendering
        if (window.ShadyCSS !== undefined && !window.ShadyCSS.nativeShadow) window.ShadyCSS.ScopingShim.prepareAdoptedCssText(styles.map((s)=>s.cssText), this.localName);
        else if (0, $d55c951de13cf645$export$b4d10f6001c083c2) this.renderRoot.adoptedStyleSheets = styles.map((s)=>s.styleSheet);
        else // This must be done after rendering so the actual style insertion is done
        // in `update`.
        this._needsShimAdoptedStyleSheets = true;
    }
    connectedCallback() {
        super.connectedCallback();
        // Note, first update/render handles styleElement so we only call this if
        // connected after first update.
        if (this.hasUpdated && window.ShadyCSS !== undefined) window.ShadyCSS.styleElement(this);
    }
    /**
     * Updates the element. This method reflects property values to attributes
     * and calls `render` to render DOM via lit-html. Setting properties inside
     * this method will *not* trigger another update.
     * * @param _changedProperties Map of changed properties with old values
     */ update(changedProperties) {
        super.update(changedProperties);
        const templateResult = this.render();
        if (templateResult instanceof (0, $99e433cdec05ae56$export$ce95ebd39b69fb27)) this.constructor.render(templateResult, this.renderRoot, {
            scopeName: this.localName,
            eventContext: this
        });
        // When native Shadow DOM is used but adoptedStyles are not supported,
        // insert styling after rendering to ensure adoptedStyles have highest
        // priority.
        if (this._needsShimAdoptedStyleSheets) {
            this._needsShimAdoptedStyleSheets = false;
            this.constructor._styles.forEach((s)=>{
                const style = document.createElement("style");
                style.textContent = s.cssText;
                this.renderRoot.appendChild(style);
            });
        }
    }
    /**
     * Invoked on each update to perform rendering tasks. This method must return
     * a lit-html TemplateResult. Setting properties inside this method will *not*
     * trigger the element to update.
     */ render() {}
}
/**
 * Ensure this class is marked as `finalized` as an optimization ensuring
 * it will not needlessly try to `finalize`.
 *
 * Note this property name is a string to prevent breaking Closure JS Compiler
 * optimizations. See updating-element.ts for more information.
 */ $fe586ba0757c37f7$export$3f2f9f5909897157["finalized"] = true;
/**
 * Render method used to render the lit-html TemplateResult to the element's
 * DOM.
 * @param {TemplateResult} Template to render.
 * @param {Element|DocumentFragment} Node into which to render.
 * @param {String} Element name.
 * @nocollapse
 */ $fe586ba0757c37f7$export$3f2f9f5909897157.render = (0, $36bba013f4fc4ae3$export$b3890eb0ae9dca99);


class $35da740d59af89ba$var$MyElement extends (0, $fe586ba0757c37f7$export$3f2f9f5909897157) {
    static get properties() {
        return {
            message: {
                type: String
            },
            myArray: {
                type: Array
            },
            myBool: {
                type: Boolean
            }
        };
    }
    static get styles() {
        return (0, $d55c951de13cf645$export$dbf350e5966cf602)`
      p {
        font-family: Roboto;
        font-size: 16px;
        font-weight: 500;
      }
      .red {
        color: red;
      }
      .blue {
        color: blue;
      }
    `;
    }
    constructor(){
        super();
        this.message = "Hello world! From my-element";
        this.myArray = [
            "an",
            "array",
            "of",
            "test",
            "data"
        ];
        this.myBool = true;
    }
    render() {
        return (0, $c90bd6824c7bfa57$export$c0bb0b647f701bb5)`
      <p class="${this.myBool ? "red" : "blue"}">styled paragraph</p>
      <p>${this.message}</p>
      <ul>
        ${this.myArray.map((item)=>(0, $c90bd6824c7bfa57$export$c0bb0b647f701bb5)`
              <li>${item}</li>
            `)}
      </ul>
      ${this.myBool ? (0, $c90bd6824c7bfa57$export$c0bb0b647f701bb5)`
            <p>Render some HTML if myBool is true</p>
          ` : (0, $c90bd6824c7bfa57$export$c0bb0b647f701bb5)`
            <p>Render some other HTML if myBool is false</p>
          `}
      <button @click="${this.clickHandler}">Click</button>
    `;
    }
    clickHandler(event) {
        console.log(event.target);
        this.myBool = !this.myBool;
    }
}
customElements.define("my-element", $35da740d59af89ba$var$MyElement);


//# sourceMappingURL=index.4d08c3d7.js.map
